import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Quote } from './quotesModel';

export interface LtcPlanningQuotesState {
  data: Quote[];
  isLoading: boolean;
  error: string | null;
  lastFetchedAt: number | null;
}

const initialState: LtcPlanningQuotesState = {
  data: [],
  isLoading: false,
  error: null,
  lastFetchedAt: null,
};

const ltcPlanningQuotesSlice = createSlice({
  name: 'ltcPlanningQuotes',
  initialState,
  reducers: {
    postLtcPlanningQuotesQueryRequest(state, action: PayloadAction<FetchQuotesPayload>) {
      state.isLoading = true;
      state.error = null;
    },
    postLtcPlanningQuotesQueryResponse(state, action: PayloadAction<Quote[]>) {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
      state.lastFetchedAt = Date.now();
    },
    postLtcPlanningQuotesQueryFailure(state, action: PayloadAction<{ message?: string }>) {
      state.isLoading = false;
      state.error = action.payload?.message || 'Failed to fetch LTC planning quotes';
    },
    clearLtcPlanningQuotes(state) {
      state.data = [];
      state.error = null;
      state.lastFetchedAt = null;
    },
  },
});

export const {
  postLtcPlanningQuotesQueryRequest,
  postLtcPlanningQuotesQueryResponse,
  postLtcPlanningQuotesQueryFailure,
  clearLtcPlanningQuotes,
} = ltcPlanningQuotesSlice.actions;

export const ltcPlanningQuotesReducer = ltcPlanningQuotesSlice.reducer;

